import { render, staticRenderFns } from "./dialog-time-setting.vue?vue&type=template&id=275d9dc2&scoped=true"
import script from "./dialog-time-setting.vue?vue&type=script&lang=js"
export * from "./dialog-time-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275d9dc2",
  null
  
)

export default component.exports